<div class="d-flex align-items-center justify-content-center">
    <span class="align-middle">
        <div class="d-flex align-items-center justify-content-center mb-3">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
        </div>
        <div class="d-block">
            Loading Geotools
        </div>
    </span>
</div>